import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-input-filter-table',
  standalone: true,
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  template: `
    <mat-form-field
      appearance="outline"
      class="buscador-tabla"
      [matTooltip]="tooltip">
      <mat-icon matPrefix>{{icon}}</mat-icon>
      <mat-label>{{label}}</mat-label>
      <input matInput
             (keyup)="onFilter($event)"
             [placeholder]="placeholder"
             #input />
    </mat-form-field>
  `,
  styleUrl: './input-filter-table.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputFilterTableComponent {
  @Input() label = 'Buscar';
  @Input() placeholder = 'Buscar';
  @Input() icon = 'search';
  @Input() tooltip = 'Escriba al menos 2 caracteres para filtrar';
  @Input() minLength = 2;
@Output() filterChange = new EventEmitter<Event>();

onFilter(event: Event) {
  const target = event.target as HTMLInputElement;
  const value = target.value.trim();

  if (value.length >= this.minLength || value.length === 0) {
    this.filterChange.emit(event);
  }
}
}
